import React from "react";
import { renderHTML } from "components/util/render_util";
import Table from "components/collections/Table";

const ConversationResult = ({ 
  message,
  result,
  schema,
}) => {
  return <div className={`d-flex flex-column animate__animated animate__fadeIn animate__faster mx-3 mb-1 align-items-start mw-75 overflow-auto`}>
    <div className={`message`}>
      <div>
        {message ?
          <div className="mb-1"><i>{renderHTML(message)}</i></div> : null
        }
        {schema && result ?
          schema.length > 0 ?
            <Table
              rawValues={result ?? []}
              structure={schema ?? []}
              isReadOnly={true}
              showImport={false}
              /> :
            <div id="chat-result-container" className="mb-2">{result}</div> : null
        }
      </div>
    </div>
  </div>;

}

export default ConversationResult;